<template>
  <v-btn
    v-model="inputValue"
    small
    v-bind:color="color"
    v-bind:href="link"
    target="_blank"
    ><v-icon>{{ mdi }}</v-icon
    >{{ text }}</v-btn
  >
</template>

<script>
import { objectTranslator } from "../../helper/translator";
export default {
  name: "buttonNews",
  props: ["text", "link", "color", "mdi", "value"],
  methods: {
    objectTranslator,
  },
  data() {
    return {};
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
